export function truncateUrl(text: string, maxLength: number = 16): string {
  // Remove http://, https://, and www.
  const cleanText = text
    .replace(/^https?:\/\//, "") // Remove http:// or https://
    .replace(/^www\./, ""); // Remove www.

  return cleanText.length > maxLength
    ? `${cleanText.slice(0, maxLength)}...`
    : cleanText;
}
